import { PageShell, Section } from "@/components/PageShell";

export default function Terms() {
  return (
    <PageShell
      title="Terms and Conditions"
      subtitle="The terms that apply when you use CommandCenterADHD and purchase the product."
      testid="terms-page"
    >
      <div className="space-y-2" data-testid="terms-intro">
        <p className="font-semibold text-white" data-testid="terms-effective-date">Effective date: September 23, 2026</p>
        <p>These Terms cover both the CommandCenterADHD website and the Command Center app for iOS and Android.</p>
      </div>

      <Section heading="Product eligibility and use">
        <p>
          CommandCenterADHD is a digital Notion template intended for personal
          planning use. By purchasing or using it you confirm that you can enter
          into these terms and that you will use the product in line with this
          agreement and the license.
        </p>
      </Section>

      <Section heading="Digital delivery">
        <p>
          The product is delivered digitally. After purchase you receive an
          access link by email and on the confirmation page. There is no
          physical product and nothing is shipped.
        </p>
      </Section>

      <Section heading="Payment terms">
        <p>
          Prices are shown in United States dollars. Payment is processed by our
          third party payment providers at checkout. Your purchase is a one time
          payment for the product described on the pricing section.
        </p>
      </Section>

      <Section heading="Refunds">
        <p>
          Try it for 30 days. If it does not fit your routine, request a full
          refund. The 30 day period begins on your purchase date. To request a
          refund, email support@commandcenteradhd.com from the address you used
          at checkout. Full details are on the
          {" "}
          <a href="/refund-policy" className="font-semibold text-[#A8D5F5] hover:text-white">Refund Policy</a>
          {" "}
          page.
        </p>
      </Section>

      <Section heading="Acceptable use">
        <p>
          You agree not to copy, resell, redistribute, or publicly share the
          template or its content, and not to misuse the community or support
          channels. We may suspend access for activity that breaches these terms
          or the license.
        </p>
      </Section>

      <Section heading="Account and access responsibilities">
        <p>
          Access is tied to the email you used at checkout and is delivered
          through a private link. You are responsible for keeping your access
          link private. If you lose it, you can recover it using the Recover
          Access page.
        </p>
      </Section>

      <Section heading="Intellectual property">
        <p>
          All content, structure, wording, layout, logos, and branding remain
          the property of CommandCenterADHD. Your purchase grants a personal
          license to use the product and does not transfer ownership.
        </p>
      </Section>

      <Section heading="Product availability">
        <p>
          We may update, improve, or change the product and its included
          materials over time. We aim to keep access available but do not
          guarantee uninterrupted availability of the site or third party
          services.
        </p>
      </Section>

      <Section heading="Limitation of liability">
        <p>
          CommandCenterADHD is an organizational tool and is provided as is.
          It is not medical advice or ADHD treatment. To the extent permitted by
          law, we are not liable for indirect or consequential losses arising
          from use of the product.
        </p>
      </Section>

      <Section heading="Governing law">
        <p>
          These terms are governed by the applicable laws of the jurisdiction in
          which CommandCenterADHD operates. Any dispute will be handled under
          that governing law.
        </p>
      </Section>

      <Section heading="Contact">
        <p>
          Questions about these terms can be sent to
          {" "}
          <a href="mailto:support@commandcenteradhd.com" className="font-semibold text-[#A8D5F5] hover:text-white">
            support@commandcenteradhd.com
          </a>
          .
        </p>
      </Section>
    </PageShell>
  );
}
